<template>
    <div v-if="visible" class="modal-backdrop" role="presentation" @click.self="$emit('close')">
      <div class="modal-card" role="dialog" aria-modal="true" aria-labelledby="modal-confirm-title">
        <p class="modal-kicker">JULIAM ARCADE</p>
        <h2 id="modal-confirm-title">Liga generada</h2>
        <p class="modal-message">{{ message }}</p>
        <p class="modal-link">{{ link }}</p>
        <div class="modal-actions">
          <button class="copy-button" type="button" @click="copyLink">Copiar liga</button>
          <button class="close-button" type="button" @click="$emit('close')">Cerrar</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { useToast } from "vue-toastification";
  export default {
    setup() {      
      const toast = useToast();
      return { toast }
    },
    props: {
      visible: Boolean,
      link: String,
      message: {
        type: String,
        default: 'Este link ha sido enviado por correo al usuario.'
      }
    },
    methods: {
      copyLink() {
        navigator.clipboard.writeText(this.link)
          .then(() => {
            this.toast.success('Link copiado al portapapeles');
          })
          .catch(() => {
            this.toast.error('No se pudo copiar el enlace');
          });
      }
    }
  }
  </script>
  
  <style scoped>
.modal-backdrop { position: fixed; z-index: 1000; inset: 0; display: grid; place-items: center; padding: 20px; background: rgba(1, 4, 15, .78); backdrop-filter: blur(12px); }
.modal-card { width: min(100%, 520px); border: 1px solid rgba(114, 245, 255, .38); padding: 28px; color: #f7f8ff; background: linear-gradient(150deg, rgba(16, 27, 59, .98), rgba(6, 10, 26, .98)); box-shadow: 0 28px 90px rgba(0, 0, 0, .58), 0 0 35px rgba(114, 245, 255, .09); }
.modal-kicker { margin: 0 0 8px; color: #72f5ff; font: 900 11px var(--juliam-mono); letter-spacing: .18em; }
h2 { margin: 0; font-family: var(--juliam-display); font-size: 30px; text-transform: uppercase; }
.modal-message { color: #aeb5cc; line-height: 1.5; }
.modal-link { overflow-wrap: anywhere; border: 1px solid rgba(255, 255, 255, .1); padding: 12px; color: #ff8edb; background: rgba(2, 6, 18, .55); font-family: var(--juliam-mono); font-size: 12px; }
.modal-actions { display: flex; gap: 10px; margin-top: 20px; }
.modal-actions button { flex: 1; border: 1px solid rgba(114, 245, 255, .4); padding: 12px 15px; color: #f7f8ff; background: transparent; font: 900 11px var(--juliam-mono); letter-spacing: .1em; text-transform: uppercase; cursor: pointer; }
.modal-actions .copy-button { color: #041017; background: #72f5ff; }
  </style>
  
